import { useMutation, useQueryClient } from '@tanstack/react-query';

import envVars from '../../../constants/envVars';
import { useSetNotification } from '../../../context/Notification';
import useRequest from '../../../hooks/useRequest';
import {
    ApiEnvelope,
    ApiEnvelopeError,
    CustomDemographics,
    CustomDemographicsPayload
} from '../types';
import { CUSTOM_DEMOGRAPHICS_KEY } from './constants';

const useUpdateCustomDemographics = (
    member_id: number | null | undefined,
    onSuccess?: () => void
) => {
    const req = useRequest();
    const setNotification = useSetNotification();
    const queryClient = useQueryClient();

    return useMutation<CustomDemographics, ApiEnvelopeError, CustomDemographicsPayload>({
        mutationFn: (body) =>
            req<ApiEnvelope<CustomDemographics>>({
                url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/custom-demographics/`,
                method: 'PUT',
                body: JSON.stringify(body)
            }).then((response) => response.data),
        // The PUT returns the saved row; the cache holds the raw envelope (`select` unwraps it).
        onSuccess: (saved) => {
            queryClient.setQueryData<ApiEnvelope<CustomDemographics | null>>(
                [CUSTOM_DEMOGRAPHICS_KEY, member_id],
                (old) => old && { ...old, data: saved }
            );
            setNotification({ message: 'Supplemental demographics updated', icon: 'checkmark' });
            onSuccess?.();
        },
        onError: (error) => error
    });
};

export default useUpdateCustomDemographics;
